import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import DataTable from "../../component/DataTable";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const tableHeader = ["Category", "Images", "Sets", "Status"];
const tbody = ["category_name", "image_count", "batch_count", "status"];

export default function GalleryListing() {
  const [galleries, setGalleries] = useState([]);
  useEffect(() => {
    ApiRequest("GET", ApiEndpoints.gallery.list)
      .then((response) => setGalleries(response.galleries || []))
      .catch((error) => toast.error(error.response?.data?.message || "Unable to load galleries."));
  }, []);

  const handleDelete = useCallback(async (gallery_id) => {
    if (!window.confirm("Delete this gallery and all its images?")) return;
    try {
      const response = await ApiRequest("POST", ApiEndpoints.gallery.delete, { gallery_id });
      toast.success(response.message);
      setGalleries((current) => current.filter((gallery) => gallery._id !== gallery_id));
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to delete gallery.");
    }
  }, []);

  const pagename = { name: "Gallery Management", user: "Admin", innerpage: "Gallery" };
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-gallery">Add +</Link>
        <DataTable data={galleries} tableHeader={tableHeader} tbody={tbody}
          editPath="edit-gallery" onDelete={handleDelete} />
      </div>
    </>
  );
}
